module.exports = __webpack_public_path__ + "static/media/man-about-to-lift-barbell-2261477@3x.eea17c02.jpg";